// extracted by mini-css-extract-plugin
export default {"rulesContent":"ViewerRulesTab_rulesContent__aeWqu"};